/**
 * Parses a parameter string into a number and unit.
 *
 * @param param - The parameter string to parse.
 * @returns An object containing the parsed number and unit.
 */
export function parseParameter(param: string) {
	const number = parseFloat(param);
	const unit = param.replace(number.toString(), '');
	return { number, unit, raw: param };
}
